import React from 'react';
import { BozpDocumentNewsResponseDTO, BozpDocumentNewsType } from '../../../../ApiOld/Api/ApiServerVov';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { NotificationsNone, ReportProblem, TextSnippet } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface MobileDocumentItemProps {
    item: BozpDocumentNewsResponseDTO;
    buttonTitle?: string;
    onClick?: () => void;
}

const MobileDocumentItem: React.FC<MobileDocumentItemProps> = ({ item, buttonTitle, onClick }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const fileExtension = item.file?.split('.').pop()?.toLowerCase() ?? "";

    const getTypeString = (type?: BozpDocumentNewsType) => {
        switch (type) {
            case BozpDocumentNewsType.Document:
                return t('document');
            case BozpDocumentNewsType.News:
                return t('news');
            case BozpDocumentNewsType.Bozp:
                return t('bozp');
            default:
                return t('document');
        }
    }

    const getIcon = (type?: BozpDocumentNewsType) => {
        switch (type) {
            case BozpDocumentNewsType.Document:
                return <TextSnippet color={'primary'} fontSize='large' />;
            case BozpDocumentNewsType.News:
                return <NotificationsNone color={'primary'} fontSize='large' />;
            case BozpDocumentNewsType.Bozp:
                return <ReportProblem color={'primary'} fontSize='large' />;
            default:
                return <TextSnippet color={'primary'} fontSize='large' />;
        }
    }

    const getShowRead = (item: BozpDocumentNewsResponseDTO) => {
        if (item.type === BozpDocumentNewsType.Document) {
            return true;
        }
        else if (item.type === BozpDocumentNewsType.News) {
            return true;
        }
        else if (item.type === BozpDocumentNewsType.Bozp) {
            return !item.isRead && !item.isRejected;
        }
        return !item.isRead;
    }

    return (
        <Box className="mobile-document-item" display={'flex'} alignItems={'center'} justifyContent={'space-between'} width={'100%'} padding={1} bgcolor={theme.palette.background.paper} boxShadow={3} borderRadius={'10px'} marginBottom={'8px'}>
            <Box display={'flex'} alignItems={'center'} >
                {getIcon(item.type)}
                <Stack spacing={0.2} ml={1}>
                    <Typography fontSize={'9px'} bgcolor={'darkgray'} color={'white'} width={'60px'} textAlign={'center'}>{getTypeString(item.type).toUpperCase()}</Typography>
                    <Typography fontSize={'11px'}>{item.name}</Typography>
                </Stack>
            </Box>
            {getShowRead(item) && <Button size='small' onClick={onClick}>{item.type === BozpDocumentNewsType.Bozp ? t('sign') : t('read')}</Button>}
        </Box>
    );
};

export default MobileDocumentItem;